module.exports = __webpack_public_path__ + "img/eyes_male_asian_round_mask.f917077c.png";